export const API_URL = 'https://api.themoviedb.org/3/movie';
export const SEARCH_API_URL = 'https://api.themoviedb.org/3/search/movie';
export const IMAGE_URL = 'https://image.tmdb.org/t/p/w500';
export const IMAGE_URL_ORIG = 'https://image.tmdb.org/t/p/original';
